// extracted by mini-css-extract-plugin
module.exports = {"container":"Travel_container__3zbXR","link":"Travel_link__8nu4Y","imageWrapper":"Travel_imageWrapper__cUBft","image":"Travel_image__Dw5_Z","text":"Travel_text__mHj69"};